import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { MultiplierSection, ImplantsSection, UnspecifiedSection } from '../../sections';

const RatesTab: React.FC = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>
        Rates & Pricing Configuration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Configure contract rates, multipliers, and pricing rules for different service types.
      </Typography>

      <Stack spacing={3}>
        <MultiplierSection />
        <ImplantsSection />
        <UnspecifiedSection />
      </Stack>
    </Box>
  );
};

export default RatesTab;